import { defaultValue, ICustomer } from 'app/modules/customer/model/customer.model';
import { ACTION_TYPES } from './subscription-actions';

export interface IDocumentMetadata {
  type: string;
}

export interface IDocument {
  uuid: string;
  metadata: IDocumentMetadata;
}

export interface Subscription {
  subscriptionNumber: string;
  legalEndDateReflection: Date;
  loading: boolean;
  createInProgress: boolean;
  errorMessage?: string;
  errorSignMessage?: string;
  offers: string[];
  shortOfferCode: string;
  signTxnCompletedAt: string;
  signTxnUrl: string;
  signTxnId: string;
  status: string;
  externalRef: string;
  source: any;
  documentsSigned: IDocument[];
  paymentMethod?: 'CASH' | 'ONE_SHOT_PAYMENT' | 'AUTOMATED_PAYMENT' | 'OTHER_DEBIT' | '';
  subscriber: any;
}

export const initialState: Subscription = {
  subscriptionNumber: '',
  legalEndDateReflection: null,
  loading: false,
  createInProgress: false,
  offers: [],
  shortOfferCode: undefined,
  signTxnCompletedAt: null,
  source: undefined as any,
  signTxnUrl: null,
  signTxnId: null,
  status: null,
  documentsSigned: [],
  externalRef: '',
  errorMessage: '',
  errorSignMessage: '',
  paymentMethod: '',
  subscriber: null
};

export type SubscriptionState = Readonly<Subscription>;

// --- Actions Types

export interface SetSubscription {
  type: typeof ACTION_TYPES.SET_SUBSCRIPTION;
  payload: { subscriptionNumber: string; customer: ICustomer; offers: string[]; signTxnCompletedAt: string };
}

export interface SetInitializeSubscription {
  type: typeof ACTION_TYPES.SET_INITIALIZE_SUBSCRIPTION;
  payload: { offers: string[] };
}

export interface CreatePendingSubscription {
  type: typeof ACTION_TYPES.CREATE_PENDING_SUBSCRIPTION;
  payload: { subscriptionNumber: string };
}

// --- Create Union Type

export type SubscriptionActions = SetSubscription | SetInitializeSubscription | CreatePendingSubscription;
